/**
 * Application Configuration
 *
 * @deprecated This file is maintained for backwards compatibility.
 * New code should import directly from '@/config/season' instead.
 *
 * @example
 * // Old (deprecated):
 * import { APPLICATION_CONFIG } from '@/config/application';
 *
 * // New (preferred):
 * import { SEASON_CONFIG, getCurrentFees, getCurrentFeePhase } from '@/config/season';
 */

import { SEASON_CONFIG, getCurrentFees, getCurrentFeePhase } from './season';
import { STRIPE_CONFIG, CURRENCY } from './season/constants';

/**
 * @deprecated Use SEASON_CONFIG.application from '@/config/season' instead
 */
export const APPLICATION_CONFIG = {
  status: SEASON_CONFIG.application.status,
  deadlines: SEASON_CONFIG.application.deadlines,
  fees: {
    currency: CURRENCY,
    /**
     * @deprecated Use getCurrentFees() from '@/config/season' instead
     */
    getCurrentFees: getCurrentFees,
    /**
     * @deprecated Use getCurrentFeePhase() from '@/config/season' instead
     */
    getCurrentPhase: getCurrentFeePhase
  },
  stripe: {
    publishableKey: STRIPE_CONFIG.publishableKey,
    allowedParameters: STRIPE_CONFIG.allowedParameters
  }
} as const;
